export * from './makeDescriptorsGetter';
export * from './descriptorsFactory';
export * from './getValue';
export * from './hasByType';
export * from './hasTerm';
export * from './hasTerms';
export * from './mergeTerms';
export * from './isValid';
export * from '../../types/interfaces';
export * from './isDescriptorActive';
